import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { messages as m } from '../../constants';
import * as D from '../../deps';

import PodcastCategoryGridItem from './PodcastCategoryGridItem';

import './BackstagePodcastMoreFromCategory.scss';

const integrationData = {
  contentSection: D.Constants.ContentSections.BackstageContentSections.CATEGORY_MORE,
};
const visibilitySettings = {
  offsets: {
    bottom: -1 * D.Constants.Styling.GlobalStyleConstants.GRID_ITEM_FOOTER_HEIGHT,
  },
};

const CategoryGridItemWithLogger = D.withVisibilityLogger(
  integrationData,
  visibilitySettings,
)(PodcastCategoryGridItem);

class BackstagePodcastMoreFromCategory extends React.Component {
  static propTypes = {
    pandoraId: PropTypes.string.isRequired,
    categoryId: PropTypes.string,
  };

  render() {
    if (!this.props.categoryId) return null;
    return (
      <D.Utils.Context.AppContextIntegrationData data={integrationData}>
        <D.ContentSection title={<FormattedMessage {...m.moreFromCategory} />}>
          <div className='BackstagePodcastMoreFromCategory__content'>
            <CategoryGridItemWithLogger pandoraId={this.props.pandoraId} />
          </div>
        </D.ContentSection>
      </D.Utils.Context.AppContextIntegrationData>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const catalogDetails = D.getDetails(state, ownProps.pandoraId);
  const categories =
    D.Utils.Core.getFromMap(catalogDetails, 'categories') ||
    D.Utils.Core.getFromMap(catalogDetails, 'programCategories');

  return {
    categoryId: categories && categories.size > 0 ? categories.first() : null,
  };
}

export default connect(mapStateToProps)(BackstagePodcastMoreFromCategory);
